import { render, staticRenderFns } from "./OushiDiaoxianItem.vue?vue&type=template&id=c7b59e6c&scoped=true&"
import script from "./OushiDiaoxianItem.vue?vue&type=script&lang=js&"
export * from "./OushiDiaoxianItem.vue?vue&type=script&lang=js&"
import style0 from "./OushiDiaoxianItem.vue?vue&type=style&index=0&id=c7b59e6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b59e6c",
  null
  
)

export default component.exports